<template>
    <div>
        <v-progress-linear
          indeterminate
          height="6"
          color="blue darken-2"
          v-if="loading"
          absolute
        ></v-progress-linear>
        <v-row no-gutters>
            <v-col cols="12">
                <v-col cols="12">
                    <h1>Roles</h1>
                </v-col>
                <v-col cols="12" v-if="visbile">
                    <v-simple-table>
                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Role ID
                                </th>
                                <th class="text-left">
                                    Name
                                </th>
                                <th class="text-left">
                                    Document
                                </th>
                                <th class="text-left order-heading">
                                    Order
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>
                                    <span class="spanopt">Download</span>
                                </td>
                                <td>
                                    <span class="spanopt1">C</span>
                                    <span class="spanopt1">U</span>
                                    <span class="spanopt1">D</span>
                                    <span class="spanopt1">AS</span>
                                    <span class="spanopt1">WD</span>
                                    <span class="spanopt1">REJ</span>
                                    <span class="spanopt1">EX</span>
                                    <span class="spanopt1">QA</span>
                                    <span class="spanopt1">DE</span>
                                    <span class="spanopt1">FIN</span>
                                    <span class="spanopt1">IH</span>
                                    <span class="spanopt1">OH</span>
                                    <span class="spanopt1">QAF</span>
                                    <span class="spanopt1">CR</span>
                                    <span class="spanopt1">ATS</span>
                                    <span class="spanopt1">STC</span>
                                </td>
                            </tr>
                            <tr v-for="item in roles" :key="item.id">
                                <td> {{ item.id }}</td>
                                <td>{{ item.tname }}</td>
                                <td>
                                    <span class="spanopt">
                                        <v-checkbox  v-model="item.permissionCode.can_download.value"></v-checkbox>
                                    </span>
                                </td>
                                <td>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.add_orders.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.change_orders.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.delete_orders.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_assign.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_waiting_docs.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_rejected_docs.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_examine.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_quality_assurance.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_data_entry.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_finished.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_in_house.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_on_hold.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_quality_assurance_feedback.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_client_rejected.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_approved_to_send.value"></v-checkbox></span>
                                    <span class="spanopt1"><v-checkbox v-model="item.permissionCode.view_send_to_client.value"></v-checkbox></span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" class="text-center">
                                    <label><b>C</b> - Create,</label>&nbsp;
                                    <label><b>U</b> - Update,</label>&nbsp;
                                    <label><b>D</b> - Delete,</label>&nbsp;
                                    <label><b>AS</b> - Assign,</label>&nbsp;
                                    <label><b>WD</b> - Waiting Docs,</label>&nbsp;
                                    <label><b>REJ</b> - Rejected Docs,</label>&nbsp;
                                    <label><b>EX</b> - Examine,</label>&nbsp;
                                    <label><b>QA</b> - Quality Assurance,</label>&nbsp;
                                    <label><b>DE</b> - Data Entry,</label>&nbsp;
                                    <label><b>FIN</b> - Finished,</label>&nbsp;
                                    <label><b>IH</b> - In House,</label>&nbsp;
                                    <label><b>OH</b> - On Hold</label>&nbsp;
                                    <label><b>QAF</b> - QA Feedback</label>&nbsp;
                                    <label><b>CR</b> - Client Rejected</label>&nbsp;
                                    <label><b>ATS</b> - Approved To Send</label>&nbsp;
                                    <label><b>STC</b> - Send To Client</label>&nbsp;
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" class="text-center">
                                    <v-btn color="primary" :loading="btnloading" v-on:click="saveroles">Save</v-btn>
                                </td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { GETALLROLES, GETALLPERMISSIONS, SAVEPERMISSIONS } from '@/store/actions.type'
export default {
  name: 'UserRoles',
  data () {
    return {
      loading: true,
      visbile: false,
      btnloading: false,
      roles: [],
      permissions: []
    }
  },
  mounted () {
    this.$store
      .dispatch(GETALLPERMISSIONS)
      .then(response => {
        console.log(response)
        this.permissions = response
        console.log(response)
        this.getRolesData()
      })
  },
  methods: {
    getRolesData () {
      this.$store
        .dispatch(GETALLROLES)
        .then(response => {
          console.log(response)
          this.roles = []
          response.forEach(element => {
            this.loading = false
            element.tname = this.getRoleName(element.name)
            element.permissionCode = {}
            for (let j = 0; j < this.permissions.length; j++) {
              let codename = this.permissions[j].codename
              element.permissionCode[codename] = {}
              element.permissionCode[codename].id = this.permissions[j].id
              element.permissionCode[codename].value = false
              for (let k = 0; k < element.permissions.length; k++) {
                if (element.permissions[k].codename === codename) {
                  element.permissionCode[codename].value = true
                  break
                }
              }
            }
            this.roles.push(element)
          })
          // this.roles = response
          console.log(this.roles)
          this.visbile = true
        })
    },
    getRoleName (value) {
      value = value.replace('_', ' ')
      return value.replace(
        /\w\S*/g,
        function (value) {
          return value.charAt(0).toUpperCase() + value.substr(1).toLowerCase()
        }
      )
    },
    saveroles () {
      this.btnloading = true
      let payload = { 'rolesdata': JSON.stringify(this.roles) }
      this.$store
        .dispatch(SAVEPERMISSIONS, payload)
        .then(response => {
          this.btnloading = false
          console.log(response)
          this.permissions = response
          console.log(response)
        })
        .catch(response => {
          this.btnloading = false
        })
      console.log(SAVEPERMISSIONS)
    }
  }
}
</script>
<style scoped>
.spanopt {
    min-width:2em;
    display:inline-block;
}
.spanopt1{
    min-width: 3.5em;
    display:inline-block;
}
.v-data-table td{
    font-weight:normal
}
.v-data-table th {
    font-size: 14px !important;
}
.order-heading{
    padding-left: 15% !important;
}
</style>
